module.exports = __webpack_public_path__ + "img/brief_picture_03.80b9df7a.png";